import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import * as Paths from '../../../../core/constants';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'dbx-partner-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatNavList, MatListItem, MatIcon, TranslatePipe, MatTooltipModule],
  templateUrl: './partner-sidebar.component.html',
  styleUrl: './partner-sidebar.component.scss',
})
export class PartnerSidebarComponent {
  @Input() isCollapsed = false;
  readonly Paths = Paths;
}
